import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { COVERAGE_LIST, UNCOVERAGE_LIST } from "./utils/content";
import { EXTERNAL_LINKS, INTERNAL_PATHS } from "routes/paths";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const Guarantee = () => (
  <div className="guarantee">
    <ReactHelmetWithProvider>
      <meta
        name="description"
        content="Our customers are important to us at GCX. That's why we've added a members protection program. It's safe, secure and easy enough to make every buying experience a memorable one."
      />
      <title>Member Protection - GCX</title>
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL + INTERNAL_PATHS.GUARANTEE}
      />
    </ReactHelmetWithProvider>
    <h1>Buy With Confidence</h1>
    <h2>90 Day Money-Back Guarantee</h2>
    <p>
      GCX is built upon the concept of trust. We hold our buyers and sellers to
      the highest of standards. Whether you’re buying discounted cards, earning
      GCX Cash for face value cards, or selling cards for cash, we want to
      ensure you have the most positive experience on GCX. With this in mind,
      every order is backed by the following Money-Back Guarantee.
    </p>
    <p>For 90 Days from your original date of purchase, we cover:</p>
    <ul>
      {COVERAGE_LIST.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </ul>
    <p></p>
    <p>
      For a period of 90 days from your original date of purchase, we cover:
    </p>
    <ul>
      <li>
        Physical cards not received within 30 days from the date of purchase on
        GCX, provided that you let GCX know within the first 90 days your
        physical card never arrived. Our Money-Back Guarantee does not cover
        cards that the US Postal Service can confirm were delivered to the
        address you provided.
      </li>
    </ul>
    <p></p>
    <p>Our 90 Day Money-Back Guarantee does not cover:</p>
    <ul>
      {UNCOVERAGE_LIST.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </ul>
    <p></p>
    <p>
      The 90 Day Money-Back Guarantee covers the purchase price of the card, not
      any savings, discount or GCX Cash the buyer received at the time of
      purchase. If a portion of the card was redeemed, only a partial refund
      will be provided. If you have any questions or would like to request a
      refund for your order under the 90 Day Money-Back Guarantee, please
      contact GCX Member Services through our{" "}
      <NavLink to={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}>Help Center</NavLink>.
    </p>
  </div>
);
